// @flow

import React from 'react'
import styled from 'styled-components'
import { mediaMin, mediaMax } from 'frontend_core/dist/styles/media'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Colors from 'components/styles/colors'
import {
  spacing,
  fontSize,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import MainContents from 'components/templates/MainContents'
import { type ReservationType } from 'types/reservation'
import Button from 'components/atoms/Button'
import Description from 'components/atoms/Description'
import ReservationListHeading from 'components/molecules/ReservationListHeading'
import PaidPaymentForm from 'components/organisms/PaidPaymentForm'

export type PropTypes = {}
export default props => (
  <MainContents>
    <ReservationListHeading>
      {i18n.t('page.dashboard.reservation.wordPaidSeparate.0')}
      {i18n.t('page.dashboard.reservation.wordPaidSeparate.1')}
      <LogoImage src={imagePath('www/common/paid_logo.png')} width="62" />
      {i18n.t('page.dashboard.reservation.wordPaidSeparate.2')}
      {i18n.t('page.dashboard.reservation.wordPaidSeparate.3')}
    </ReservationListHeading>
    <DescriptionWrap>
      <Description>
        {i18n.t('page.dashboard.reservation.paidLeadText1')}
        <DescriptionBr />
        {i18n.t('page.dashboard.reservation.paidLeadText2')}
        <DescriptionBr />
        {i18n.t('page.dashboard.reservation.paidLeadText3')}
      </Description>
    </DescriptionWrap>
    <BorderBoxWrap>
      <BorderBox>
        <dl>
          <BorderBoxHeading>
            {i18n.t('page.dashboard.reservation.aboutPaid')}
            <LogoImage src={imagePath('www/common/paid_logo.png')} width="49" />
          </BorderBoxHeading>
          <BorderBoxDetail>
            <ul>
              <BorderBoxListItem>
                {i18n.t('page.dashboard.reservation.aboutPaidText1')}
              </BorderBoxListItem>
              <BorderBoxListItem>
                {i18n.t('page.dashboard.reservation.aboutPaidText2')}
              </BorderBoxListItem>
              <BorderBoxListItem>
                {i18n.t('page.dashboard.reservation.aboutPaidText3')}
              </BorderBoxListItem>
              <BorderBoxListItem>
                {i18n.t('page.dashboard.reservation.aboutPaidText4.0')}
                <a href={wwwUrl('/about/paid')}>
                  {i18n.t('page.dashboard.reservation.aboutPaidText4.1')}
                </a>
                {i18n.t('page.dashboard.reservation.aboutPaidText4.2')}
              </BorderBoxListItem>
            </ul>
          </BorderBoxDetail>
        </dl>
      </BorderBox>
    </BorderBoxWrap>
    <PaidPaymentForm {...props} />
    <ButtonWrap>
      <Button
        buttonType="medium"
        colorType="blue"
        tag="button"
        fontSizePc="{16}"
        buttonHeightPc="48"
        fontSizeSp="{14}"
        fullWidthSp
        onClick={props.onClickPayExaminationDryrun}
      >
        {i18n.t('page.dashboard.reservation.toConfirm')}
      </Button>
    </ButtonWrap>
  </MainContents>
)

const DescriptionBr = styled.br`
  ${mediaMax.phone`	
    display: none;
  `};
`
const BorderBoxWrap = styled.div`
  margin-top: ${spacing.medium_2}px;
  ${mediaMin.phone`	
    margin-top: ${spacing.large}px;
  `};
`
const BorderBoxHeading = styled.dt`
  font-weight: bold;
`
const BorderBoxDetail = styled.dd`
  margin-top: ${spacing.small_2}px;
`
const BorderBoxListItem = styled.li`
  font-size: ${fontSize.small_2}px;
  line-height: 1.4;
  padding-left: 1em;
  text-indent: -1em;
  margin-top: 4px;
`
const LogoImage = styled.img`
  height: auto;
`
const DescriptionWrap = styled.div`
  margin-top: ${spacing.small_2}px;
`
const ButtonWrap = styled.div`
  margin-top: ${spacing.medium_3}px;
  ${mediaMin.phone`	
    margin-top: ${spacing.large}px;
  `};
`
const BorderBox = styled.div`
  border: 1px solid ${Colors.grayD};
  border-radius: ${borderRadius}px;
  padding: ${spacing.medium}px;
  ${mediaMin.phone`	
    padding: ${spacing.medium_2}px;
  `};
`



// WEBPACK FOOTER //
// ./src/components/pages/ReservationPayExaminationPage/index.jsx